/* eslint-disable no-empty */
import { upload } from "./files.module/upload.module.js";
import { media } from "./files.module/media.module.js";
import { move } from "./files.module/move.module.js";
import { down } from "./files.module/down.module.js";
import { useCookies } from "vue3-cookies";

export const files = {
    namespaced: true,
    modules: {
        upload,
        media,
        move,
        down,
    },
    state: {
        fileArray: [],
        selectArray: [],        
        bRecycle: false,
        rootDir: "",
        curDir: [],
        isForceDelete: false,
    },
    getters: {
        imageFiles(state) {            
            return state.fileArray
                .filter(file => file.type?.startsWith('image/') && file.file.name)
                .map(file => file.file.name);
        },
        fileArrayTotalSize: (state) => {
            return state.fileArray.reduce((sum, file) => {
                return sum + (file.meta?.size || 0);
            }, 0);
        },
        selectArrayTotalSize: (state) => {
            return state.selectArray.reduce((sum, file) => {
                return sum + (file.meta?.size || 0);
            }, 0);
        },
        currentDirPath: (state) => {
            return state.curDir.join('/');
        },
        getMtimeMsByFileName: (state) => (fileName) => {
            const target = state.fileArray.find(item => item.file.name === fileName);
            //console.log(target)
            return target?.meta?.mtimeMs || 0;
        }
    },
    actions: {
        setRootDir({ commit }, file) {            
            commit('addRootDir', file)
        },
        setFile({ commit }, file) {
            commit('addFile', file);
        },
        setSortFiles({ commit }) {
            commit('sortFileArray');
        },
        setFiles({ commit }, file) {
            commit('changeFileArray', file);            
        },
        updateSelected(context, tenant) {
            if (tenant.checked) {
                const file = this.state.files.fileArray.find(f => f.file.name === tenant.value);
                if (file) {
                    const meta = { ...file.meta }; // 예시로 meta에 updatedAt 추가
                    context.commit('addSelectedTenant', { name: tenant.value, isFile: file.isFile, meta: meta });
                }
            } else {
                context.commit('removeSelectedTenant', tenant.value)
            }
        },
        setCleanSelectArray({ commit } ) {
            commit('cleanSelectArray')
        },        
        setChangeFileName({ commit }, file) {
            commit('changeFileName', file)
        },
        setCleanFileArray({ commit }) {
            commit('cleanFileArray')
        },
        setUpdateCurDirArray({ commit }, dir) {
            commit('updateCurDirArray', dir)
        }
    },
    mutations: {
        addRootDir(state, file) {
            state.rootDir = file;  
        },
        addFile(state, file) {            
            var index = state.fileArray.findIndex(i => i.file.name == file.file.name);            
            if (index === -1) {
                state.fileArray = [...state.fileArray, file]; // 새 항목 추가
            } else {
                // 기존 항목 교체 후 새 배열 할당
                const newArray = [...state.fileArray];
                newArray[index] = file;
                state.fileArray = newArray;
            }
        },
        sortFileArray(state) {
            state.fileArray = state.fileArray.sort((a, b) => {
                const nameA = (a.file?.name || '').toString();
                const nameB = (b.file?.name || '').toString();

                // 폴더 우선 정렬
                if (a.isFile && !b.isFile) return 1;
                if (!a.isFile && b.isFile) return -1;

                // 이름 숫자 기준 자연 정렬
                return nameA.localeCompare(nameB, undefined, { numeric: true, sensitivity: 'base' });
            });
        },
        changeFileArray(state, file) {
            state.fileArray = file.sort((a, b) => {
                const nameA = (a.file?.name || '').toString();
                const nameB = (b.file?.name || '').toString();

                // 폴더 우선 정렬
                if (a.isFile && !b.isFile) return 1;
                if (!a.isFile && b.isFile) return -1;

                // 이름 숫자 기준 자연 정렬
                return nameA.localeCompare(nameB, undefined, { numeric: true, sensitivity: 'base' });
            });
        },
        addSelectedTenant(state, tenant) {
            state.selectArray.push(tenant)
            //state.selectArray.sort((a, b) => {  
            //    var nameA = a.name.toUpperCase();
            //    var nameB = b.name.toUpperCase(); 
            //    if (nameA < nameB)
            //        return -1;
            //    else if (nameA > nameB)
            //        return 1;
            //    return 0;
            //});
        },
        removeSelectedTenant(state, name) {
            state.selectArray = state.selectArray.filter(tenant => { 
                return tenant.name != name
            })            
        },
        deleteFile(state) {
            for (const del of state.selectArray) { 
                var index = state.fileArray.findIndex(i => i.file.name == del.name);
                //console.log("files index : " + index + ",   files name : " + del.name)
                state.fileArray.splice(index, 1);
            }
            state.selectArray.length = 0;
        },
        cleanSelectArray(state) {
            state.selectArray.length = 0;
        },        
        changeFileName(state, file) {            
            var index = state.fileArray.findIndex(i => i.file.name == file);
            state.fileArray.splice(index, 1);
        },
        cleanFileArray(state) {
            state.fileArray.length = 0;
        },
        updateCurDirArray(state, dir) {
            state.curDir = dir.split(/[\\/]/).filter(Boolean);
        },
        changeForceDelete(state, value) {
            state.isForceDelete = value
        }
    }
};